export const HTTP_STATUSES = {
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NO_CONTENT: 204,
  DELETED: 204,
  NOT_MODIFIED: 304,
  REDIRECT: 307,
  MANAGER_APPROVAL_REQUIRE: 370,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
  CONFLICT: 409,
};

export const PROMISE_STATUSES = {
  PENDING: "pending",
  FULFILLED: "fulfilled",
  REJECTED: "rejected",
};
